import React, { useMemo, useState } from "react";
import styled from "styled-components";
import Modal from "../../../components/Modal";
import { Typography, TextField, Autocomplete, Chip } from "@mui/material";
import { StyledText } from "../../../components";
import * as Yup from "yup";
import { get, isEmpty } from "lodash";

const MainContainer = styled.div`
  padding-bottom: 40px;
  min-height: 100px;
  .numberField {
    margin-top: 20px;
  }
  .responseContainer {
    margin-top: 12px;
    .listItem {
      display: flex;
      flex-direction: row;
      margin-left: 10px;
    }
  }
`;

const TestNotification = ({ onSubmit, onCancel, apiResponse, isLoading }) => {
  const [selectedNumbers, setSelectedNumbers] = useState([]);
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const isAllValidNumbers = useMemo(() => {
    let returnVal = true;
    selectedNumbers.forEach((phone) => {
      const schema = Yup.string()
        .min(10)
        .max(10)
        .required()
        .matches(phoneRegExp);
      const isValid = schema.isValidSync(phone);
      if (!isValid) returnVal = false;
    });
    return returnVal;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNumbers]);

  const sentOnNumbers = useMemo(() => {
    return get(apiResponse, "notificationSentToNos") ?? [];
  }, [apiResponse]);

  const notSentOnNumbers = useMemo(() => {
    return get(apiResponse, "notificationNotSentToNos") ?? [];
  }, [apiResponse]);

  return (
    <Modal
      onSubmit={() => onSubmit(selectedNumbers)}
      confirmTitle={"Send"}
      cancelTitle={"Cancel"}
      onCancel={onCancel}
      isLoading={isLoading}
      isDisabled={!isAllValidNumbers || selectedNumbers.length === 0}
    >
      <MainContainer>
        <Typography
          variant="h6"
          textAlign={"center"}
          fontWeight={700}
          width={"100%"}
          marginBottom={1}
        >
          {"Test on Device"}
        </Typography>
        <StyledText width={"100%"}>
          {
            "You can test this notification by entering registered mobile number of your device"
          }
        </StyledText>
        <Autocomplete
          multiple
          options={[]}
          value={selectedNumbers}
          freeSolo
          onChange={(e, value) => {
            setSelectedNumbers(value);
          }}
          autoSelect
          renderTags={(value, getTagProps) =>
            value.map((phone, index) => {
              const schema = Yup.string()
                .min(10)
                .max(10)
                .required()
                .matches(phoneRegExp);
              const isValid = schema.isValidSync(phone);
              return (
                <Chip
                  key={index}
                  label={phone}
                  size="small"
                  variant="outlined"
                  color={isValid ? "default" : "error"}
                  {...getTagProps({ index })}
                  hasError
                />
              );
            })
          }
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                id="mobileNumbers"
                label="Mobile Numbers"
                required
                size="small"
                error={!isAllValidNumbers}
                placeholder={
                  selectedNumbers.length > 0
                    ? ""
                    : "Enter Registered Mobile Number"
                }
                className="numberField"
                helperText={`Press the "Enter" key to input each number, allowing you to add multiple numbers sequentially.`}
                InputLabelProps={{
                  ...params.inputProps,
                  shrink: true,
                }}
              />
            );
          }}
        />
        {(!isEmpty(sentOnNumbers) || !isEmpty(notSentOnNumbers)) && (
          <div className="responseContainer">
            <Typography variant="body2" marginBottom={0.5}>
              {"Notification Result:"}
            </Typography>
            {sentOnNumbers.map((item) => (
              <div className="listItem">
                <Typography variant="caption">{`• ${item}`}</Typography>
                <Typography variant="caption" color={"green"} marginLeft={1}>
                  {"✔ Sent"}
                </Typography>
              </div>
            ))}
            {notSentOnNumbers.map((item) => (
              <div className="listItem">
                <Typography variant="caption">{`• ${item}`}</Typography>
                <Typography
                  variant="body2"
                  fontWeight={700}
                  color={"red"}
                  marginLeft={1}
                >
                  {"×"}
                </Typography>
                <Typography variant="caption" color={"red"} marginLeft={0.5}>
                  {"Number is not registered"}
                </Typography>
              </div>
            ))}
          </div>
        )}
      </MainContainer>
    </Modal>
  );
};

export default TestNotification;
